export default __webpack_public_path__ + "static/media/icons-search.ae108268.svg";